// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__3LWfc","filled":"IconReviewStar_filled__3DSbW"};